export const ESI_REPORT_INITIAL_STATE = {
  report_month: ""
}